module.exports = __webpack_public_path__ + "f32df4e462f1f2c60802c4826836c042.png";